import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
// @material-ui/icons
import Check from '@material-ui/icons/Check';
import ExpandMore from '@material-ui/icons/ExpandMore';
import customSelectStyle from 'components/CustomInput/style/customSelectStyle';

const CustomSelect = (props) => {
  const {
    classes,
    labelText,
    placeholder,
    customFont,
    error,
    success,
    data,
    value,
    handleChange,
    multiple,
    id,
    customClass,
  } = props;

  const rootClass = cx({
    [classes.root]: true,
    [classes.selected]: true,
    [customClass]: customClass,
  });
  const successClass = cx({
    [classes.feedback]: true,
    [classes.labelRootSuccess]: true,
  });

  const selectClass = cx({
    [classes.select]: true,
    [classes.selectError]: error,
    [classes.selectSuccess]: success && !error,
  });

  const selectLabel = cx({
    [classes.selectLabel]: true,
    [classes.customLabel]: customFont,
  });

  return (
    <FormControl fullWidth className={rootClass}>
      {labelText && (
        <InputLabel htmlFor='simple-select' className={selectLabel} classes={{ root: classes.rootLabel }}>
          {labelText}
        </InputLabel>
      )}

      <Select
        multiple={multiple}
        IconComponent={(props) => <ExpandMore {...props} />}
        MenuProps={{
          className: classes.selectMenu,
        }}
        renderValue={(selected) => {
          if (!Array.isArray(selected)) selected = [selected];
          selected = selected.filter((_) => _);
          const needPlaceholder = selected.length === 0;

          const renderValueClass = cx({
            [classes.selectMenuPlaceholder]: needPlaceholder,
          });

          return <span className={renderValueClass}>{needPlaceholder ? placeholder : selected.join(', ')}</span>;
        }}
        classes={{
          select: selectClass,
        }}
        value={value}
        onChange={(event) => handleChange(event, id)}
        disableUnderline
        displayEmpty>
        <MenuItem
          disabled
          classes={{
            root: classes.selectMenuItem,
          }}>
          {placeholder || 'Sélectionner'}
        </MenuItem>
        {Boolean(data.length) &&
          data.map((element, index) => {
            return (
              <MenuItem
                key={index}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected,
                }}
                value={multiple ? element : element.id}>
                {multiple ? element : element.name}
              </MenuItem>
            );
          })}
      </Select>
      {success && <Check className={successClass} />}
    </FormControl>
  );
};

CustomSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  labelText: PropTypes.node,
  //value: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  data: PropTypes.array,
  handleChange: PropTypes.func,
  CustomSelect: PropTypes.bool,
  customClass: PropTypes.string,
};

CustomSelect.defaultProps = {
  multiple: false,
  customFont: false,
  customClass: '',
};

export default withStyles(customSelectStyle)(CustomSelect);
